/* Animate only decoded, existing configurator photographs while the tile is visible. */
(() => {
  const ready = new WeakSet(), reduced = matchMedia('(prefers-reduced-motion: reduce)');
  function setup() {
    document.querySelectorAll('[data-mh-photo-preview]').forEach(preview => {
      if (ready.has(preview)) return;
      ready.add(preview);
      const group = preview.closest('details'), frames = [...preview.querySelectorAll('[data-mh-preview-frame]')];
      let version = 0, played = false, visible = false, active;
      function reset() {
        version++; active?.cancel(); played = false;
        frames.forEach((frame, index) => { frame.style.opacity = index ? '0' : '1'; frame.style.filter = ''; });
      }
      async function motion(frame, keys, duration) {
        active?.cancel();
        active = frame.animate(keys, { duration, easing: 'ease-in-out', fill: 'forwards' });
        await active.finished.catch(() => {});
      }
      async function play() {
        if (played || !visible || !group.open || reduced.matches || !preview.isConnected) return;
        played = true;
        const current = ++version;
        try {
          await Promise.all([...preview.querySelectorAll('img')].map(async img => {
            if (img.dataset.src) img.src = img.dataset.src;
            await img.decode();
          }));
        } catch { return; } // Keep the first photograph if another asset cannot load.
        for (let index = 1; index < frames.length; index++) {
          if (current !== version || !preview.isConnected) return;
          await motion(frames[index - 1], [{ opacity: 1 }, { opacity: 1 }], 850);
          if (current !== version) return;
          await motion(frames[index - 1], [{ opacity: 1, filter: 'blur(0)' }, { opacity: 0, filter: 'blur(3px)' }], 160);
          if (current !== version) return;
          frames[index - 1].style.opacity = '0'; active.cancel();
          await motion(frames[index], [{ opacity: 0, filter: 'blur(3px)' }, { opacity: 1, filter: 'blur(0)' }], 220);
          if (current !== version) return;
          frames[index].style.opacity = '1'; active.cancel();
        }
      }
      group.addEventListener('toggle', () => { if (group.open) play(); else reset(); });
      reduced.addEventListener('change', () => { reset(); play(); });
      const observer = new IntersectionObserver(entries => {
        visible = entries.some(entry => entry.isIntersecting);
        if (visible) play(); else reset();
      }, { threshold: .2 });
      observer.observe(preview);
    });
  }
  setup();
  document.addEventListener('shopify:section:load', setup);
})();
